import type { ReactNode } from 'react'

import cn from 'classnames'
import StepsBar, { TStepsBarProps } from './StepsBar'

type Props = {
  title: ReactNode
  children?: ReactNode
  description?: ReactNode
  renderBreadcrumbs?: () => ReactNode
  renderBtns?: () => ReactNode
  className?: string
  steps?: TStepsBarProps['steps']
}

const Title = (props: Props) => {
  const {
    title,
    children,
    description,
    renderBreadcrumbs,
    renderBtns,
    className,
    steps,
  } = props

  const containerCn = cn('bg-white mb-8 ', {
    'border-b border-gray-100 shadow-sm py-4': !steps,
    'shadow-sm': steps,
    [className ?? '']: className,
  })

  const titleCn = cn('text-2xl font-bold tracking-tight text-gray-900', {
    'pb-4': steps,
  })

  return (
    <div className={containerCn}>
      <div className="max-w-5xl mx-auto px-4 space-y-4 justify-start md:space-y-0 md:space-x-6 md:flex md:items-center md:justify-between">
        <div>
          <h1 className={titleCn}>{title}</h1>
          {description && (
            <p className="my-1 text-gray-600 text-sm">{description}</p>
          )}
          {renderBreadcrumbs && (
            <div className="mt-1">{renderBreadcrumbs()}</div>
          )}
          {children}
        </div>
        {renderBtns && (
          <div className="mt-3 sm:mt-0 flex justify-start">{renderBtns()}</div>
        )}
      </div>
      {steps && <StepsBar steps={steps} />}
    </div>
  )
}

export default Title
